module.exports = __webpack_public_path__ + "static/media/TacoMan.74d438de.png";